module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/regular/arrow-circle-up-0521496a8ecd6402250899f80467d0d8.svg";